const API = 'https://premium.audiomeans.fr';
const STRIPE_KEY = 'pk_live_51H8TCBGeQlSZqzmu3phTgRwOYb2RmjDP6somFTk8bX8YBQpGx3RePxBsgClIe2kZjI4sRpoVDgR22uQPp6OVok5R00khbSgCpI';

const TOKEN = 'cust-auth-token';

export { API, TOKEN, STRIPE_KEY };
